import { DbInvoiceExpenseInfos } from "./db-invoice-expense-infos";
import { GenericResponse } from "./generic-response";

export enum BillingMetricType {
  UsersBasic = "UsersBasic",
  UsersAdmin = "UsersAdmin",
  TransferInBandwidth = "TransferInBandwidth", // Not used - reserved
  TransferOutBandwidth = "TransferOutBandwidth",
  MediaProcessingMinutes = "MediaProcessingMinutes",
  IngestCountRawVideo = "IngestCountRawVideo",
  StorageDisk = "StorageDisk",
}

export class BillingMetricValue {
  type: BillingMetricType = BillingMetricType.UsersBasic;
  included: number = 0;
  consumed: number = 0;
  overdue: number = 0;
}

export class BillingMetricsData {
  values: BillingMetricValue[] = [];
}

export class ListExpensesResponse extends GenericResponse<ListExpensesResponse> {
  expenses: DbInvoiceExpenseInfos[] | null = null;
  lastUpdate: Date | null = null;
  metrics: BillingMetricsData | null = null;

  constructor(init?: Partial<ListExpensesResponse>) {
    super();
    Object.assign(this, init);
  }
}
